// Port of api/fuel/app/classes/insights/shelf/longest.php

import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'
import Config from 'offline/model/config'

function excludedGameIds(userId) {
	var config = Config.user(userId)
	var unplayed = (config.lists && config.lists.unplayed) ? config.lists.unplayed : {}
	var exclude = Array.isArray(unplayed.games) ? unplayed.games.slice() : []

	if (!unplayed.trade) {
		var tradeRows = Util.queryFast(
			'SELECT game_id FROM collection WHERE collection_fortrade = 1 AND user_id = ' + userId + ' AND collection_plays = 0'
		)
		for (var i = 0; i < tradeRows.length; i++) exclude.push(parseInt(tradeRows[i].game_id, 10))
	}

	if (!unplayed.rated) {
		var ratedRows = Util.queryFast(
			'SELECT game_id FROM collection WHERE collection_rating > 0 AND user_id = ' + userId + ' AND collection_plays = 0'
		)
		for (var j = 0; j < ratedRows.length; j++) exclude.push(parseInt(ratedRows[j].game_id, 10))
	}

	return exclude.filter(Boolean)
}

export default Segment.extend({
	name: 'longest',
	priority: 10,
	run: function(type, owner, userIndex, detail, filter, vars) {
		var longest = []
		var period = (filter.longest === 'all') ? 'all' : 'current'
		period = (vars && vars.longest !== undefined) ? vars.longest : period
		var limit = detail ? 1000 : 5
		var exclude = excludedGameIds(owner.get_id())
		var gameTrack = {}

		var logGroup = Util.queryFast(
			'SELECT g.game_name AS n, l.log_date AS d, l.log_context AS c, l.game_id AS g' +
			' FROM log_user_collection l, game g' +
			' WHERE l.user_id = ' + owner.get_id() +
			' AND l.game_id = g.game_id' +
			' AND g.game_type = 1' +
			(exclude.length ? (' AND l.game_id NOT IN(' + Util.in(exclude) + ')') : ''),
			null,
			'g',
			true
		)

		var groupKeys = Object.keys(logGroup)
		for (var i = 0; i < groupKeys.length; i++) {
			var group = logGroup[groupKeys[i]]
			var gid = parseInt(group[0].g, 10)

			if (!gameTrack[gid]) {
				gameTrack[gid] = {
					id: gid,
					added: 0,
					removed: 0,
					name: group[0].n,
					addedCount: 0,
					removedCount: 0
				}
			}

			for (var j = 0; j < group.length; j++) {
				var log = group[j]
				var target = (parseInt(log.c, 10) === Constants.LOG_CONTEXT_ADDED) ? 'added' : 'removed'
				gameTrack[gid][target] = Util.date_start(parseInt(log.d, 10))
				gameTrack[gid][target + 'Count']++
			}

			if (gameTrack[gid].removed < gameTrack[gid].added && gameTrack[gid].removedCount < gameTrack[gid].addedCount) {
				gameTrack[gid].removed = 0
			}
		}

		if (Object.keys(gameTrack).length) {
			var firstPlays = Util.queryFast(
				'SELECT MIN(p.play_date) AS d, p.game_id AS g, SUM(p.play_count) AS c' +
				' FROM play p' +
				' WHERE p.user_id = ' + owner.get_id() +
				' AND p.game_id IN (' + Util.in(Object.keys(gameTrack)) + ')' +
				' GROUP BY p.game_id',
				null,
				'g'
			)

			var candidates = Object.keys(gameTrack)
			for (var k = 0; k < candidates.length; k++) {
				var candidate = gameTrack[candidates[k]]
				if (!candidate.added) continue

				var firstPlay = firstPlays[candidate.id]

				if (firstPlay) {
					if (parseInt(firstPlay.d, 10) >= candidate.added) {
						var removedBeforePlay = candidate.removed && candidate.removed < parseInt(firstPlay.d, 10)
						longest.push({
							id: parseInt(candidate.id, 10),
							name: candidate.name,
							from: parseInt(candidate.added, 10),
							to: removedBeforePlay ? parseInt(candidate.removed, 10) : parseInt(firstPlay.d, 10),
							length: removedBeforePlay ? (candidate.removed - candidate.added) : (parseInt(firstPlay.d, 10) - candidate.added),
							plays: parseInt(firstPlay.c, 10),
							played: (parseInt(firstPlay.d, 10) < candidate.removed || !candidate.removed) ? parseInt(firstPlay.d, 10) : 0,
							own: !candidate.removed
						})
					}
				} else {
					longest.push({
						id: parseInt(candidate.id, 10),
						name: candidate.name,
						from: parseInt(candidate.added, 10),
						to: parseInt(candidate.removed, 10),
						length: candidate.removed ? (candidate.removed - candidate.added) : (Util.time() - candidate.added),
						played: 0,
						plays: 0,
						own: !candidate.removed
					})
				}
			}
		}

		if (longest.length) {
			longest = Util.sort_by_field(longest, 'length', 'desc')
			this._data.longest = longest

			if (period === 'current') {
				longest = longest.filter(function(item) {
					return !item.to && !item.played
				})
			}

			if (longest.length > limit) longest = longest.slice(0, limit)

			for (var li = 0; li < longest.length; li++) this._references.games.push(parseInt(longest[li].id, 10))
		} else {
			this._data.longest = []
		}

		return {
			longest: longest
		}
	}
})
